export interface AffiliateCreateQuoteProps {
  services: {
    serviceId: string;
    quantity?: number;
  }[];
  currency: AffiliateQuoteCurrencyTypes;
  clientEmail: string;
  clientName: string;
}

export enum AffiliateQuoteCurrencyTypes {
  USD = 'USD',
  INR = 'INR',
}

export interface AffiliateQuote {
  id: string;
  affiliateFirmId: string;
  Services?: {
    serviceId: string;
    quantity?: number;
    unitPrice?: string;
    itemId?: string;
    description?: string;
  }[];
  estimatedTotal: number;
  currency: AffiliateQuoteCurrencyTypes;
  clientEmail: string;
  clientName: string;
  validUntil: string;
  createdAt: string;
  status: 'VALID' | 'EXPIRED';
}

export interface AffiliateUpdateQuoteProps {
  Services?: {
    serviceId: string;
    quantity?: number;
  }[];
  currency?: AffiliateQuoteCurrencyTypes;
  clientEmail?: string;
  clientName?: string;
}
export enum ChargebeeServiceFamilyIds {
  COMMENDA_SERVICES = 'Commenda-Services',
}

export enum ChargebeeServiceStatus {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
  DELETED = 'deleted',
}

export type ItemTypeEnum = 'plan' | 'addon' | 'charge';

export type TSerializedItem = {
  // id is item_id from price
  id: string;
  name: string;
  external_name: string;
  period_unit?: string;
  description?: string;
  status: ChargebeeServiceStatus;
  item_family_id: ChargebeeServiceFamilyIds;
  period?: number;
  item_id: string;
  type: ItemTypeEnum;
  pricing_model?: 'flat_fee' | 'per_unit';
  item_type?: ItemTypeEnum;
  price?: number;
  currency_code?: string;
};
